import axiosInstance from '../axios';
import endpoints from '../endpoints';

const authService = {
  // Register new user with host
  register: async (userData) => {
    const response = await axiosInstance.post(endpoints.auth.register, userData);
    return response.data;
  },

  // Login user
  login: async (credentials) => {
    const response = await axiosInstance.post(endpoints.auth.login, credentials);
    return response.data;
  },

  // Get user profile
  getProfile: async () => {
    const response = await axiosInstance.get(endpoints.auth.profile);
    return response.data;
  },

  forgotPassword: async (phone) => {
  const response = await axiosInstance.post(endpoints.auth.forgotPassword, { phone });
  return response.data;
},

verifyResetOtp: async (phone, otp) => {
  const response = await axiosInstance.post(endpoints.auth.verifyResetOtp, { phone, otp });
  return response.data;
},

resetPassword: async (phone, newPassword) => {
  const response = await axiosInstance.post(endpoints.auth.resetPassword, { phone, newPassword });
  return response.data;
},
};

export default authService;